// Batch AT Stage C — online wizard for the KYC-Formular für
// natürliche Personen.
//
// Underscore suffix on the parent segment (`dokumente_`) escapes the
// `dokumente.tsx` layout — URL stays /dokumente/kyc but the wizard
// renders as a standalone page (parent route has no <Outlet/>).

import { createFileRoute } from '@tanstack/react-router';
import { KycWizard } from '@/components/dokumente/KycWizard';

export const Route = createFileRoute('/_app/dokumente_/kyc')({
  component: KycWizard,
});
